module.exports = __webpack_public_path__ + "static/assets/b9c886ce0382819a2ae97120a2ba0a7a.png";